import { Flex, useDisclosure } from "@chakra-ui/react";
import Logo from "./Logo";
import PrimaryButton from "./PrimaryButton";
import { Box, Container, Text } from "@chakra-ui/layout";
import SidebarLink from "./SidebarLink";
import HomeIcon from "./icons/HomeIcon";
import BarChartIcon from "./icons/BarChartIcon";
import ScanIcon from "./icons/ScanIcon";
import CartIcon from "./icons/CartIcon";
import TicketIcon from "./icons/TicketIcon";
import BellIcon from "./icons/BellIcon";
import EarIcon from "./icons/EarIcon";
import ContactIcon from "./icons/ContactIcon";
import FolderIcon from "./icons/FolderIcon";
import GearIcon from "./icons/GearIcon";
import SidebarFooter from "./SidebarFooter";
import FoldableSidebarLink from "./FoldableSidebarLink";
import FoldableSidebarLinkItem from "./FoldableSidebarLinkItem";
import DeliveryNoteIcon from "./icons/DeliveryNoteIcon";
import ScanModal, { ScanModalHandle } from "./modals/ScanModal";
import { useRef } from "react";
import BuildingOutlinedIcon from "./icons/BuildingOutlinedIcon";
import { useNotificationCount } from "../hooks/notifications.hooks";

function SidebarAdmin() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: stats } = useNotificationCount();
  const ref = useRef<ScanModalHandle>(null);

  return (
    <Flex
      w="280px"
      h="100vh"
      bg="zinc.50"
      py="20px"
      direction="column"
      justifyContent="space-between"
      position={"fixed"}
    >
      <Container>
        <Flex
          justifyContent="space-between"
          alignItems="center"
          gap="10px"
          ml="10px"
        >
          <Flex alignItems="center" gap="10px">
            <Logo />
            <Text
              fontWeight="700"
              fontSize="20px"
              lineHeight="24px"
              display="inline"
            >
              Supembouts
            </Text>
          </Flex>
          <SidebarLink
            icon={
              <Box position="relative">
                <BellIcon lineHeight="21px" w="21px" h="21px" />
                {stats?.notification.unread !== undefined &&
                  stats?.notification.unread !== 0 && (
                    <Box
                      position="absolute"
                      top="-4"
                      right="-5"
                      backgroundColor="#DC2626"
                      color="white"
                      borderRadius="100rem"
                      w="24px"
                      h="24px"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      {stats?.notification.unread < 10
                        ? stats?.notification.unread
                        : ""}
                    </Box>
                  )}
              </Box>
            }
            to="/notifications"
          ></SidebarLink>
        </Flex>

        <PrimaryButton
          mt="24px"
          onClick={() => {
            if (ref.current) {
              ref.current.reset();
              onOpen();
            }
          }}
        >
          <ScanIcon mr="8px" /> Scan
        </PrimaryButton>

        <Box mt="20px">
          <SidebarLink icon={<HomeIcon lineHeight="21px" />} to="/dashboard">
            Dashboard
          </SidebarLink>
          <SidebarLink icon={<BarChartIcon lineHeight="21px" />} to="/stats">
            Statistiques
          </SidebarLink>
          <FoldableSidebarLink
            icon={<CartIcon lineHeight="21px" />}
            label="Commandes"
            to="/orders"
          >
            <FoldableSidebarLinkItem to="/orders/print">
              À imprimer
            </FoldableSidebarLinkItem>
            <FoldableSidebarLinkItem to="/orders/exports">
              Exports
            </FoldableSidebarLinkItem>
          </FoldableSidebarLink>
          <SidebarLink
            icon={<DeliveryNoteIcon lineHeight="21px" />}
            to="/orders/deliverynote"
          >
            Bons de livraison
          </SidebarLink>
          <SidebarLink icon={<TicketIcon lineHeight="21px" />} to="/tickets">
            Tickets SAV / Assistance
          </SidebarLink>
          <SidebarLink icon={<ContactIcon lineHeight="21px" />} to="/patients">
            Patients
          </SidebarLink>
          <SidebarLink
            icon={<BuildingOutlinedIcon lineHeight="21px" />}
            to="/contacts"
          >
            Contacts
          </SidebarLink>
          <SidebarLink icon={<EarIcon lineHeight="21px" />} to="/products">
            Produits
          </SidebarLink>
          <SidebarLink
            icon={<FolderIcon lineHeight="21px" />}
            to="/documentation"
          >
            Documentation
          </SidebarLink>
          <SidebarLink icon={<GearIcon lineHeight="21px" />} to="/settings">
            Paramètres
          </SidebarLink>
        </Box>
      </Container>

      <SidebarFooter />

      <ScanModal ref={ref} isOpen={isOpen} onClose={onClose} onOpen={onOpen} />
    </Flex>
  );
}

export default SidebarAdmin;
